export const ShipStationMaxDigits = 9999999999.99;